import pnq from './Pune.png'
import blr from './Bengaluru.jpg'
import hsp from './Hosapete.jpg'
import mys from './Mysore.jpg'
import sod from './Sode.jpg'
import sos from './Sosale.jpg'
import atn from './Athani.jpg'
import blrm from './Bengaluru_Math.jpg'
import glb from './Gulbarga.png'
import glbm from './Gulburga_Mutt.jpg'
import hyd from './Hyderabad.jpg'
import udp from './Udupi.jpg'

let workshops = [
    { src: pnq, name: 'Pune' },
    { src: blr, name: 'Purnapramati School' },
    { src: hsp, name: 'Hosapete' }, 
    { src: sos, name: 'Sosale' }, 
    { src: mys, name: 'Mysore' }, 
    { src: sod, name: 'Sode' }, 
    { src: atn, name: 'Athani' }, 
    { src: blrm, name: 'Bengaluru' }, 
    { src: glb, name: 'Gulbarga' }, 
    { src: glbm, name: 'Gulbarga' }, 
    { src: hyd, name: 'Hyderabad' }, 
    { src: udp, name: 'Udupi' }, 
];

export default workshops;